import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  ControlledCheckbox,
  ControlledRadioGroup
} from '../../../../../shared';
import BaseSection from './BaseSection';

const AvailabilitySection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  const availabilityOptions = [
    {
      value: 'available',
      label: t('available')
    },
    {
      value: 'not_available',
      label: t('notAvailable')
    },
    {
      value: 'optional',
      label: t('optional')
    }
  ];

  return (
    <>
      <BaseSection />
      <ControlledCheckbox
        control={control}
        name="flex_only_flag"
        label={t('flexOnly')}
      />
      <ControlledCheckbox
        control={control}
        name="no_duty_flag"
        label={t('noDuty')}
      />
      <ControlledRadioGroup
        direction={'row'}
        control={control}
        name="availability_type_list"
        label={t('availability_report')}
        options={availabilityOptions}
      />
    </>
  );
};

export default AvailabilitySection;
